module.exports = __webpack_public_path__ + "static/media/07_CALCINHA_DE_AMARRAR_LISA_04.a2eaeb27.jpg";